import React from 'react';

import LoadingSpin from './LoadingSpin';

interface ButtonProp {
  name?: string
  icon?: React.ReactNode
  color?: string
  outline?: boolean
  action?: Function
  type?: 'button' | 'reset' | 'submit'
  disabled?: boolean
  iconAfter?: React.ReactNode
  loading?: boolean
  full?: boolean
  textColor?: string
  colorHover?: string
  value?: number | string
  className?: string
  [key: string]: any // Permite props adicionales como data-tooltip-id
}

const Button = ({
  name,
  color = 'slate-600',
  icon,
  action,
  iconAfter,
  loading,
  disabled,
  full,
  outline,
  colorHover,
  value,
  textColor = 'white',
  type = 'button',
  className,
  ...restProps // Captura el resto de props
}: ButtonProp) => {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center rounded-md border ${outline ? 'border- border' + color : `border-transparent bg-${color}`} ${
        full ? 'w-full' : ''
      } ${!!name ? 'px-2' : 'px-3'} py-2 text-sm font-medium text-${textColor} gap-2 shadow-sm focus:outline-none ${
        disabled && 'cursor-not-allowed opacity-70'
      } hover:shadow-md ${colorHover ? 'hover:bg-' + colorHover + ' hover:text-white' : ''} transition-all duration-200 ${className}`} // <--- Transición agregada
      onClick={(e) => action && action(e.currentTarget.value)}
      disabled={loading || disabled}
      value={value && value}
      {...restProps} // Pasa el resto de props al botón
    >
      {loading ? <LoadingSpin color={textColor} /> : icon && icon}
      {name && name}
      {iconAfter && iconAfter}
    </button>
  )
}

export default Button
